import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    CircularProgress
} from '@mui/material'
import { generateTokenPubNub, getOrgById } from '../../store/actions/ManageOrgsActions'
import { toast } from 'react-toastify'

export class AddPubNubToken extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            tokenName: '',
            openTokenPubnub: false
        }
    }
    handelGenerateTokenPubNub = () => {
        const body = {
            orgId: this.props.orgId,
            tokenName: this.state.tokenName
        }
        this.props.generateTokenPubNub(body)
        this.setState({
            open: false,
            tokenName: '',
            openTokenPubnub: true
        })
        this.props.getOrgById(this.props.orgId)
    }
    copyTokenPubNub = () => {
        navigator.clipboard.writeText(this.props.orgState.pubNubToken)
        toast.success('Token Copied to Clipboard')
    }
    closeTokenPopUpPubNub = () => {
        this.setState({
            openTokenPubnub: false,
            tokenName: ''
        })
    }

    render() {
        return (
            <>
                <Button onClick={() => this.setState({ open: true })} className='individual-add-btn'>Add PubNub Token +</Button>
                <Dialog open={this.state.open} className="individual-dialog">
                    <DialogTitle>Generate PubNub Token</DialogTitle>
                    <DialogContent>
                        <input className='auth-input' style={{ marginTop: "5px" }} placeholder='Add PubNub token name' color='success' onChange={(e) => this.setState({ tokenName: e.target.value })} />
                        <p style={{ maxWidth: '400px' }}>Note: You can provide any name you like upto 15 characters. It will help you identify the token by name.</p>
                    </DialogContent>
                    <DialogActions>
                        <Button className='dialog-submit-btn' onClick={() => this.handelGenerateTokenPubNub()}>Generate</Button>
                        <Button className='dialog-cancel-btn' onClick={() => this.setState({ open: false, tokenName: '' })}>Cancel</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.openTokenPubnub}>
                    <DialogTitle>PubNub Token Details</DialogTitle>
                    <DialogContent>
                        {
                            this.props.orgState.loading ?
                                <CircularProgress /> : <input readOnly className='auth-input' value={this.props.orgState.pubNubToken}></input>
                        }
                        <p>Note: Please Keep these details safe & Secure. You can view this only once. Tokens remain valid until exclusively revoked</p>
                    </DialogContent>
                    <DialogActions>
                        <Button className='dialog-submit-btn' disabled={this.props.orgState.loading} onClick={() => this.copyTokenPubNub()}>Copy</Button>
                        <Button className='dialog-cancel-btn' onClick={() => this.closeTokenPopUpPubNub()}>Close</Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        state: state.AuthServicesList,
        orgState: state.ManageOrgsList
    }
}

const mapDispatchToProps = dispatch => ({
    generateTokenPubNub: (body) => {
        dispatch(generateTokenPubNub(body))
    },
    getOrgById: (id)=>{
        dispatch(getOrgById(id))
    }

})

export default connect(mapStateToProps, mapDispatchToProps)(AddPubNubToken)